import { Injectable } from "@angular/core";
import { Subject }    from 'rxjs/Subject';

@Injectable()
export class UtilService {
    restrictAccess = new Subject<any>();
}
